export class DustDto {
    public pm10!: number;
}